import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { APP_SETTINGS, AppSettings } from 'src/app/settings';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { DataService } from 'src/app/service/data.service';
import { StorageService } from 'src/app/service/storage.service';
import { ConstantService } from 'src/app/service/constant.service';
import { ForumApiService } from 'src/app/service/forum.api.service';
import { EncryptionService } from 'src/app/service/encryption.service';
import { GlobalValueService } from 'src/app/service/globalValue.service.';
import { NgFor, NgIf } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { MatTabsModule } from '@angular/material/tabs';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-knowledge-base-sub-category-child',
  standalone: true,
  templateUrl: './knowledge-base-sub-category-child.component.html',
  styleUrls: ['./knowledge-base-sub-category-child.component.less'],
  imports: [ NgFor, NgIf, MatTabsModule, NgxPaginationModule ],
})

export class KnowledgeBaseSubCategoryChildComponent {


  selected = 0;
  p: number = 1;

  childItem = [];
  mainBaseArray = [];
  questionsArray = [];
  childItemArray = [];
  subcategoryChild = [];
  titleArrayForKeywords = [];  
  
  categoryID: string;
  subCategory: string;
  mainCategory: string;
  childCategory: string;
  subCategoryId: string;
  categoryTitles: string;

  shimmer = false;

  private routerSubscription: Subscription;



  constructor(
    @Inject(APP_SETTINGS) private settings: AppSettings,
    private meta: Meta,
    private router: Router,
    private titleService: Title,
    private route: ActivatedRoute,
    private dataService: DataService,
    private storageService: StorageService,
    private constantService: ConstantService,
    private forumApiService: ForumApiService,
    private encryptionService: EncryptionService,
    private globalValueService: GlobalValueService
  ) {}


  ngOnInit() {
    const url = this.router.url;
    let pathSegments;
    
    if (url) {
      pathSegments = url.split('/');
    } else {
      console.error('URL is undefined or null');
    }    

    if (pathSegments && pathSegments.length > 2) {
      this.mainCategory = pathSegments[1];
      this.subCategory = pathSegments[2];
      this.childCategory = pathSegments[4];
    } else {
      console.error('URL does not contain enough segments');
    }

    this.backNavigation();

    this.dataService.data.subscribe((mainBaseArray) => {
      if(mainBaseArray.length > 0) {
        mainBaseArray.forEach(mCategoryEle => {
          if(mCategoryEle.permalink === this.mainCategory) {
              this.childItem = mCategoryEle.child;
          }          
        });
      }

      this.childItem.forEach(element => {
        if(element.child.length > 0) {
          this.childItemArray = element.child;
          element.child.forEach(childElement => {
            if(childElement.permalink === this.childCategory) {
              this.categoryID = childElement.id
              this.getArticalList(this.categoryID);
            }
          });
        }
      });
        this.selectedMenuItem();
        this.addMetaTag();
    });
  }

  addMetaTag(): void {
    try{
      this.meta.updateTag({ name: this.constantService.robots, content: this.constantService.forumPageRobotContent });
      this.childItem.forEach((element) => { 
        element.child.forEach(childEle => {
          this.categoryTitles = this.categoryTitles==undefined?"":this.categoryTitles + " " + childEle.name;
          this.titleArrayForKeywords.push(childEle.name); 
        })   

       });
       var str = this.titleArrayForKeywords.join(", ");
       this.meta.updateTag({ name: this.constantService.description, content: this.categoryTitles});
       this.meta.updateTag({ name: this.constantService.keywords, content: str });
    }  catch(e){
      console.log('Error in addMetaTag method - ',e);
    } 
  }

  selectedMenuItem(): void {
    try{
      this.childItem.forEach((value) => {
        value.child.forEach((childEle, index) => {
          if(this.categoryID == childEle.id){
            this.selected = index;
            this.subCategoryId = childEle.id;
            this.titleService.setTitle(
              this.constantService.getKnowledgeBasePageTitle(childEle.name)
            );
          }
        });
      });
    } catch(e){
      console.log('Error in selectedMenuItem method - ',e);
    }
  } 

  async getArticalList(catId: string): Promise<void> {
    try {
      this.shimmer = true;
      const portalId = this.encryptionService.decryptUsingAES_256(this.storageService.getItem(this.constantService.portalId));
      const categoryId = catId;
      const from = this.constantService.getArticleListRequestConstant.galFrom
      const limit = this.constantService.getArticleListRequestConstant.galLimit;
      const sortBy = this.constantService.getArticleListRequestConstant.galSortBy;
      const locale = this.constantService.getArticleListRequestConstant.gallocale;
      ;
    
      await this.forumApiService.articalList(portalId, categoryId, from, limit, sortBy, locale).then(async (getArticalListResponse) => {
        this.shimmer = false;
        this.categoryTitles = '';
        for(let i=0; i<getArticalListResponse.data.length; i++){
          this.questionsArray[i] = getArticalListResponse.data[i];
          this.categoryTitles = this.categoryTitles==undefined?"":this.categoryTitles + " " + getArticalListResponse.data[i].title;
          this.meta.updateTag({ name: this.constantService.description, content: this.categoryTitles});
        }
      });
    } catch (e) {
      this.shimmer = false;
      console.group('Error Occured in getArticalList : ', e);
    }
  }

  changeMenu(tabEvent: any): void {
    try {
      this.p = 1;
      this.titleService.setTitle(
        this.constantService.getKnowledgeBasePageTitle(tabEvent.tab.textLabel)
      );
      this.childItem.forEach((element) => {
        if(element.child.length > 0) {
          element.child.forEach(childEle => {
            if(tabEvent.tab.textLabel === childEle.name){
              this.questionsArray = [];
              this.getArticalList(childEle.id);
              this.subCategoryId = childEle.id;
              this.router.navigateByUrl(this.mainCategory + '/' + this.subCategory + '/' + 'subCategory' + '/' + childEle.permalink);
              this.subcategoryChild = childEle.permalink;
            }
          });
        }
      });
    } catch(e){
      console.log('Error in changeMenu method - ',e);
    }    
  }

  goTosubCategoryAnswers(questionId: string, questionTitle: string, subCatId: string): void {
    try {
      // if(localStorage.getItem(this.constantService.isLoggedIn) == this.constantService.yes){
      //   const values = this.getValues();
      //   this.setValues(values.mainCategoryValue,subCatId);
      // }
      this.router.navigate([this.mainCategory + '/' + this.subCategory + '/' + questionTitle], {queryParams: { questionId }});
    } catch(e){
      console.log('Error in goTosubCategoryAnswers method - ',e);
    }
  }


  backNavigation() {
    try {
      this.routerSubscription = this.router.events.subscribe(event => {
        if (event instanceof NavigationStart) {
          if (event.navigationTrigger === 'popstate') {
            this.dataService.data.subscribe((mainBaseArray) => {            
              if(mainBaseArray.length > 0){
                mainBaseArray.forEach(mCategoryEle => {
                  if(mCategoryEle.permalink === event.url.split("/")[1]) {
                      this.childItem = mCategoryEle.child;
                    }
                });
              }
              
              this.childItem.forEach((element) => {
                if(element.permalink === event.url.split("/")[2]){
                  element.child.forEach((childCategory, index) => {
                    const parts = event.url.split('/');
                    if(childCategory.permalink === parts[parts.length - 1]){                      
                      this.selected = index;
                    }
                  });
                }
              });
            });
          }
        }
      });
    } catch (e) {
      console.log('Error in backNavigation method - ', e);
    }
  }

}